import type { Confidence } from "../data/schema";
import { cn } from "../lib/cn";

/** Small colored pill communicating how trustworthy a factor's estimate is. */
const LABELS: Record<Confidence, string> = {
  high: "Well constrained",
  medium: "Debated",
  low: "Deeply uncertain",
};

const STYLES: Record<Confidence, string> = {
  high: "text-confidence-high border-confidence-high/40 bg-confidence-high/10",
  medium:
    "text-confidence-medium border-confidence-medium/40 bg-confidence-medium/10",
  low: "text-confidence-low border-confidence-low/40 bg-confidence-low/10",
};

export default function ConfidenceBadge({
  confidence,
}: {
  confidence: Confidence;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-wide",
        STYLES[confidence],
      )}
      title={`Confidence: ${confidence}`}
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-current" />
      {LABELS[confidence]}
    </span>
  );
}
